import script from "./NavbarMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarMobile.vue?vue&type=script&setup=true&lang=js"

import "./NavbarMobile.vue?vue&type=style&index=0&id=edf94280&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edf94280"]])

export default __exports__